<div class="content flex column">
  <div class="toolbar flex">
    <div class="schema-selector-box flex column">
      @if (enumList.length) {
        <payee-dropdown
          width="short"
          placeholder="Válassz sémát!"
          [options]="enumList"
          [selected]="selectedEnumOption"
          [displayWith]="enumLabel"
          [disabled]="enumList.length <= 1 || hasChanged"
          (selectedChange)="selectEnum($event)"
        ></payee-dropdown>
      }
      @if (enumList.length === 0) {
        <button
          payee-button
          width="short"
          disabled
        >
          Nincsenek sémák!
        </button>
      }
    </div>

    <div class="save-buttons-box flex column">
      <button
        payee-button
        width="short"
        [disabled]="!hasChanged"
        (click)="saveSchema()"
      >
        Mentés
      </button>
      <button
        payee-button
        width="short"
        color="grey-dark"
        [disabled]="!hasChanged"
        (click)="discardChanges()"
      >
        Elvetés
      </button>
    </div>

    <div class="save-buttons-box flex column">
      <button
        payee-button
        width="short"
        color="grey-dark"
        (click)="downloadselectedEnum()"
      >
        Exportálás
      </button>
      <input
        #importInput
        type="file"
        accept="application/json"
        class="import-input"
        (change)="importSchema(importInput.files!); importInput.value = ''"
      />
      <button
        payee-button
        width="short"
        color="grey-dark"
        (click)="importInput.click()"
      >
        Importálás
      </button>
    </div>
  </div>

  @if (selectedEnum()) {
    <div class="schema-grid flex column top-margin-30">
      @for (schemaRow of getPaginatedSchema(); track schemaRow; let i = $index) {
        <div class="data-row flex vcenter">
          @for (column of selectedEnum()!.descriptor.columns; track column.name) {
            <div class="data-cell">
              <!--INT-->
              @if (column.type === "int") {
                <app-custom-input-field [title]="$any(schemaRow[column.name])">
                  <input
                    #input
                    custom-input
                    pattern="\d+"
                    [value]="schemaRow[column.name]"
                    [readOnly]="column.readonly"
                    (input)="updateSchemaElement(input.value, i + page * pageSize, column.name)"
                  />
                  <span
                    custom-label
                    [class.custom-label-top]="!!input.value"
                  >
                    {{ column.name }}
                  </span>
                </app-custom-input-field>
              }
              <!--STRING-->
              @if (column.type === "string") {
                <app-custom-input-field [title]="$any(schemaRow[column.name])">
                  <input
                    #input
                    custom-input
                    [value]="schemaRow[column.name]"
                    [readOnly]="column.readonly"
                    (input)="updateSchemaElement(input.value, i + page * pageSize, column.name)"
                  />
                  <span
                    custom-label
                    [class.custom-label-top]="!!input.value"
                  >
                    {{ column.name }}
                  </span>
                </app-custom-input-field>
              }
              <!--BOOLEAN-->
              @if (column.type === "boolean") {
                <app-custom-checkbox
                  [checked]="getBooleanValue(schemaRow, column.name)"
                  [disabled]="column.readonly"
                  (changed)="updateSchemaElement($event, i + page * pageSize, column.name)"
                >
                  <span>{{ column.name }}</span>
                </app-custom-checkbox>
              }
              <!--ENUM-->
              @if (column.type === "enum") {
                <app-custom-input-field [title]="$any(schemaRow[column.name])">
                  <button
                    custom-input
                    mat-button
                    class="field-menu-button"
                    [matMenuTriggerFor]="enumMenu"
                    [disabled]="column.readonly"
                  >
                    {{ schemaRow[column.name] }}
                  </button>
                  <mat-menu
                    #enumMenu
                    xPosition="after"
                    class="no-padding"
                    panelClass="enum-editor-menu"
                  >
                    @for (enumValue of column.values; track enumValue) {
                      <button
                        mat-menu-item
                        class="field-menu-item"
                        (click)="updateSchemaElement(enumValue, i + page * pageSize, column.name)"
                      >
                        {{ enumValue }}
                      </button>
                    }
                  </mat-menu>
                  <span
                    custom-label
                    class="custom-label-top"
                  >
                    {{ column.name }}
                  </span>
                </app-custom-input-field>
              }
              <!--EXTERNAL-->
              @if (column.type === "external") {
                <app-custom-input-field [title]="getExternalLabel(schemaRow, column)">
                  <button
                    custom-input
                    mat-button
                    class="field-menu-button"
                    [matMenuTriggerFor]="schemaMenu"
                    [disabled]="column.readonly"
                  >
                    {{ getExternalLabel(schemaRow, column) }}
                  </button>
                  <mat-menu
                    #schemaMenu
                    xPosition="after"
                    class="no-padding"
                    panelClass="enum-editor-menu"
                  >
                    @for (externalItem of enums[$any(column.externalModel)]; track externalItem.id) {
                      <button
                        mat-menu-item
                        class="field-menu-item"
                        (click)="updateSchemaElement(externalItem.id, i + page * pageSize, column.name)"
                      >
                        {{ getLabel(externalItem) }}
                      </button>
                    }
                  </mat-menu>
                  <span
                    custom-label
                    class="custom-label-top"
                  >
                    {{ column.name }}
                  </span>
                </app-custom-input-field>
              }
              <!--ARRAY-->
              @if (column.type === "array") {
                <app-custom-input-field [title]="getArraySummary(schemaRow, column.name)">
                  <button
                    custom-input
                    mat-button
                    class="field-menu-button"
                    [disabled]="column.readonly"
                    (click)="editArray(schemaRow, column.name)"
                  >
                    {{ getArraySummary(schemaRow, column.name) }}
                  </button>
                  <span
                    custom-label
                    class="custom-label-top"
                  >
                    {{ column.name }}
                  </span>
                </app-custom-input-field>
              }
            </div>
          }
          <div class="delete-cell">
            <button
              payee-mini-icon-button
              color="white"
              (click)="deleteSchemaElement(i + page * pageSize)"
            >
              <payee-icon name="trash-red"></payee-icon>
            </button>
          </div>
        </div>
      }
    </div>
  }

  @if (selectedEnum()) {
    <div class="paginator flex vcenter">
      @if (selectedEnum()) {
        <button
          payee-button
          width="normal"
          (click)="addEnumElement()"
        >
          Új elem felvétele
        </button>
      }
      <button
        mat-icon-button
        (click)="prevPage()"
      >
        <mat-icon>chevron_left</mat-icon>
      </button>
      <button
        mat-icon-button
        (click)="nextPage()"
      >
        <mat-icon>chevron_right</mat-icon>
      </button>
      <div>
        {{ page * pageSize + 1 }} -
        {{ min((page + 1) * pageSize, selectedEnum()!.items.length) }}
      </div>
      &nbsp;
      <div>Összesen: {{ selectedEnum()!.items.length }}</div>
      &nbsp;
      <button
        class="paginator-menu-button"
        mat-button
        [matMenuTriggerFor]="pageSizeMenu"
      >
        {{ pageSize }}
      </button>
      <mat-menu
        #pageSizeMenu
        xPosition="after"
        class="no-padding"
        panelClass="enum-editor-menu"
      >
        @for (option of pageSizeOptions; track option) {
          <button
            mat-menu-item
            class="paginator-menu-item"
            (click)="setPageSize(option)"
          >
            <div class="flex vcenter">
              {{ option }}
            </div>
          </button>
        }
      </mat-menu>
    </div>
  }
</div>
